//src/styles/components/MuiAlert.js

import palette from "../palette";

const MuiAlert = {
  styleOverrides: {
    root: { 
      borderRadius: 8, 
      fontSize: "1rem", 
      border: `1px solid transparent` 
    },
    standardSuccess: { 
      backgroundColor: palette.success?.alpha?.['10'] || "rgba(76, 175, 80, 0.1)", 
      color: palette.success?.main || "#4caf50", 
      borderColor: palette.success?.alpha?.['30'] || "rgba(76, 175, 80, 0.3)" 
    },
    standardError: { 
      backgroundColor: palette.error?.alpha?.['10'] || "rgba(244, 67, 54, 0.1)", 
      color: palette.error?.main || "#f44336", 
      borderColor: palette.error?.alpha?.['30'] || "rgba(244, 67, 54, 0.3)" 
    },
    standardWarning: { 
      backgroundColor: palette.warning?.alpha?.['10'] || "rgba(255, 152, 0, 0.1)", 
      color: palette.warning?.main || "#ff9800", 
      borderColor: palette.warning?.alpha?.['30'] || "rgba(255, 152, 0, 0.3)" 
    },
    standardInfo: { 
      backgroundColor: palette.info?.alpha?.['10'] || "rgba(33, 150, 243, 0.1)", 
      color: palette.info?.main || "#2196f3", 
      borderColor: palette.info?.alpha?.['30'] || "rgba(33, 150, 243, 0.3)" 
    },
  },
};

export default MuiAlert;